import './polyfill' // Must be first!
import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import i18n from '@/libs/i18n'
import axios from 'axios'
import useAppConfig from '@core/app-config/useAppConfig'
import router from './router'
import store from './store'
import App from './App.vue'
import VueApexCharts from 'vue-apexcharts'

// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'

// Axios Mock Adapter
import '@/@fake-db/db'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  data() {
    return {
      timeoutId: null,
    }
  },
  created() {
    this.startTimeout()
  },
  mounted() {
    document.addEventListener('mousemove', e => {
      // this.lastClick = `x: ${e.clientX} | y: ${e.clientY}`
      this.cancelTimeout()
    })
  },
  methods: {
    startTimeout() {
      this.timeoutId = setTimeout(() => {
        this.logoutSys()
      // }, 1800000)
      }, 900000) // 15 menit
    },
    cancelTimeout() {
      clearTimeout(this.timeoutId)
      this.startTimeout()
    },
    async logoutSys() {
      const params = new URLSearchParams()
      params.append('nik', localStorage.getItem('nik'))
      params.append('emp_id', localStorage.getItem('id'))
      await axios.post(`${useAppConfig().AxiosUrl}api_mes/user-mes/autologout`, params)
      // window.localStorage.clear()
      window.location.replace(`${useAppConfig().PortalUrl}`)
    },
  },
  render: h => h(App),
}).$mount('#app')
